import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { environment } from "../../../environments/environment";
import { MzBaseModal } from "ng2-materialize";
import { Subscription, Observable, Subject } from "rxjs";
import { HttpEvent, HttpClient, HttpEventType } from "@angular/common/http";
import { DeleteItemConfirmationDialogComponent } from "../delete-item-confirmation-dialog/delete-item-confirmation-dialog.component";
import { NgxGalleryComponent } from "../ngx-gallery/ngx-gallery.component";
import { NgxGalleryImage } from "../ngx-gallery/ngx-gallery-image.model";

@Component({
  selector: "app-epic-gallery",
  templateUrl: "./epic-gallery.component.html",
  styleUrls: ["./epic-gallery.component.scss"],
})
export class EpicGalleryDialogComponent extends MzBaseModal {
  readonly env: any = environment;

  entityId: string;
  entityTypeName: string;
  entityName: string;
  attachments: string[] = [];
  previews: NgxGalleryImage[] = [];

  files: File[] = [];
  progress: number = 0;
  currentRequest: Subscription;
  httpEvents$: Observable<HttpEvent<Object>>;
  sendableFormData: FormData;
  resultSubject: Subject<boolean>;

  galleryOptions = [
    {
      image: false,
      thumbnails: false,
      width: "0px",
      height: "0px",
      previewFullscreen: true,
      previewCloseOnEsc: true,
      previewKeyboardNavigation: true,
      previewAnimation: true,
      previewInfinityMove: true,
      previewZoom: true,
      previewRotate: true,
      previewDownload: true,
      previewBullets: true,
      previewZoomStep: 0.5,
      previewZoomMax: 5,
      previewDescription: false,
      actions: [
        {
          icon: "delete",
          onClick: async (_, index) => {
            this.Gallery.preview.close();
            await this.delete(this.attachments[index]);
            this.changeDetectorRef.detectChanges();
            if (this.attachments.length > 0) {
              this.showAttachment(Math.min(index, this.attachments.length - 1));
            }
          },
        },
      ],
    },
  ];

  @ViewChild("DeleteConfirmationModal")
  DeleteConfirmationModal: DeleteItemConfirmationDialogComponent;
  @ViewChild("Gallery") Gallery: NgxGalleryComponent;

  constructor(
    public httpClient: HttpClient,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngAfterViewInit() {}

  async show(
    id: string,
    entityName: string,
    entityTypeName: string
  ): Promise<number> {
    this.resultSubject = new Subject<boolean>();
    this.modalComponent.open();
    this.entityId = id;
    this.entityName = entityName;
    this.entityTypeName = entityTypeName;
    this.attachments = await this.httpClient
      .get<string[]>(this.env.managirUrl + "/attachments/" + this.entityId)
      .first()
      .toPromise();
    this.previews = this.attachments.map((x, i) => {
      return {
        big: this.env.managirUrl + "/attachments/" + this.entityId + "/" + x,
        description: `${this.entityName} Anhang ${i + 1}.png`,
      };
    });
    this.changeDetectorRef.detectChanges();
    await this.resultSubject.first().toPromise();
    let result = this.attachments.length;
    this.modalComponent.close();
    this.entityId = null;
    this.entityName = null;
    this.entityTypeName = null;
    this.attachments.length = 0;
    this.files.length = 0;
    return result;
  }

  close() {
    this.resultSubject.next(true);
  }

  cancel() {
    if (this.currentRequest) {
      this.currentRequest.unsubscribe();
      this.currentRequest = null;
    }
    this.progress = null;
  }

  showAttachment(i: number) {
    this.Gallery.openPreview(i);
  }

  async uploadFinished() {
    this.files.length = 0;
    this.currentRequest = null;
    this.progress = 0;
    this.attachments = await this.httpClient
      .get<string[]>(this.env.managirUrl + "/attachments/" + this.entityId)
      .first()
      .toPromise();
    this.previews = this.attachments.map((x, i) => {
      return {
        big: this.env.managirUrl + "/attachments/" + this.entityId + "/" + x,
        description: `${this.entityName} Anhang ${i + 1}.png`,
      };
    });
    this.changeDetectorRef.detectChanges();
  }

  startUpload() {
    var request = this.httpClient
      .post(
        this.env.managirUrl + "/attachments/" + this.entityId,
        this.sendableFormData,
        { observe: "events", reportProgress: true }
      )
      .publish();
    this.httpEvents$ = request;
    request
      .filter((x) => x.type === HttpEventType.Response)
      .subscribe(async (_) => await this.uploadFinished());
    this.currentRequest = request.connect();
  }

  async delete(attachment: string) {
    this.modalComponent.close();
    if (await this.DeleteConfirmationModal.getResultAsync()) {
      await this.httpClient
        .delete(
          this.env.managirUrl +
            "/attachments/" +
            this.entityId +
            "/" +
            attachment
        )
        .first()
        .toPromise();
      console.log("deleted, loading attachments");
      this.attachments = await this.httpClient
        .get<string[]>(this.env.managirUrl + "/attachments/" + this.entityId)
        .first()
        .toPromise();
      this.previews = this.attachments.map((x, i) => {
        return {
          big: this.env.managirUrl + "/attachments/" + this.entityId + "/" + x,
          description: `${this.entityName} Anhang ${i + 1}.png`,
        };
      });
      this.changeDetectorRef.detectChanges();
    }
    this.modalComponent.open();
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/epic-gallery/epic-gallery.component.ts